import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Cloud, Code, Server, Code2 } from "lucide-react"; // Using Lucide React for icons
import "./css/TechTopics.css"; // Custom CSS for styling

const TechTopics = () => {
  return (
    <div className="tech-topics-section py-5">
      <Container fluid className="px-0">
        <Row className="align-items-center">
          {/* Left Side: Image with Icons */}
          <Col md={6} className="tech-topics-image">
            <div className="image-wrapper position-relative">
              <img
                src="../../../images/individuals/2.jpg" // Replace with actual image URL
                alt="Tech Topics"
                className="img-fluid"
              />
              {/* Floating Tech Icons */}
              <div className="tech-icon cloud">
                <Cloud size={40} />
              </div>
              <div className="tech-icon python">
                <Code size={40} />
              </div>
              <div className="tech-icon aws">
                <Server size={40} />
              </div>
              <div className="tech-icon angular">
                <Code2 size={40} />
              </div>
              <div className="tech-icon js">
                <Code size={40} />
              </div>
            </div>
          </Col>

          {/* Right Side: Text Content */}
          <Col md={6} className="tech-topics-text p-5">
            <h2 className="tech-topics-title">
              Access in-demand courses curated by industry experts
            </h2>
            <p className="tech-topics-description">
              CLIF.ai brings you a curated library of in-demand courses aligned
              with what top companies are actually hiring for. From technical
              skills to soft skills, every course is handpicked based on real
              industry trends and employer needs. Whether you're aiming for your
              first job or looking to up-skill, the right learning path is just
              a click away—anytime, anywhere.
            </p>
            <a href="/subscription">
              <Button className="browse-courses-btn">
                Browse Subscription
              </Button>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TechTopics;
